import {
    EuiBadge, EuiBreadcrumbs,
    EuiButton,
    EuiEmptyPrompt,
    EuiInMemoryTable,
    EuiLink, EuiPageContent, EuiPageContentHeader, EuiPageContentHeaderSection, EuiPanel,
    EuiSearchBar, EuiSpacer,
    EuiSuperDatePicker, EuiText, EuiTitle, formatDate
} from "@elastic/eui";
import React, {Fragment, useContext, useEffect, useState} from "react";
import {Store} from "../../../app/stores/store-root";
import {observer} from "mobx-react-lite";
import {Order} from "../../../app/models/order";
import {EuiSearchBarProps} from "@elastic/eui/src/components/search_bar/search_bar";
import {SearchFilterConfig} from "@elastic/eui/src/components/search_bar/search_filters";
import {NavLink, useHistory} from "react-router-dom";
import * as _ from 'lodash'
import MessageModal from "../../../app/common/message-modal";

const SupervisorOrderList = () => {
    const [selection, setSelection] = useState([]);
    const [branches, setBranches]=useState<any[]>([]);
    const [agents, setAgents]=useState<any[]>([]);
    const [loading, setLoading]=useState(false);

    //today date generator
    let d = new Date();
    const offset = d.getTimezoneOffset()
    d = new Date(d.getTime() - (offset*60*1000))
    let today = d.toISOString().split('T')[0]


    const onTimeChange = (props: any) => {
        console.log(props);
        setQuery(`CreatedAt:${props.start}`);
    };
    const history=useHistory();
//todo
    const [query, setQuery] = useState('');
    const store = useContext(Store);
    useEffect(() => {
        setLoading(true);
        store.Lookups.loadLookups().then(()=>{
            const transformed = store.Lookups.branchRegistry.map((item)=>{return {"value":item.value, "name":item.label}});
            setBranches(transformed);
        }).finally(()=>{
        });

        store.Orders.LoadAllOrders().then(() => {
            const transformed = _.uniqBy(store.Orders.Orders.map((item:Order)=>{return {'value':item.CreatedByName, 'name':item.CreatedByName}}),item=>item.value);
            setAgents(transformed);
        }).finally(()=>        setLoading(false));
    }, [])

    const openInvoice = (order: Order) => {
        store.Orders.SetCurrentOrder(order);
        history.push('/invoice');
    }
    const invoiceAction: any = {
        name: "Invoice",
        description: "Open Invoice",
        icon: "document",
        type: "icon",
        onClick: openInvoice,
    }

    const onCancel = (order: Order) => {
        order.CancelledAt = new Date();
        order.CancelledByName = `${store.Users.Name} ${store.Users.UserName}`;
        order.CancelledBySub = store.Users.Sub;
        order.CancelledByUserName = store.Users.UserName;

        //Todo : Add Are you sure you want to cancel?
        store.Orders.CancelOrder(order)
            .then(() => {
                const message = `Order ${order.Reference} has been cancelled successfully.`
                store.Modal.openModal(
                    <MessageModal message={message} success={true}/>
                );
                history.push("/");
            })
            .catch((e) => {
                store.Modal.closeModal();
                const message = `Unable to cancel order ${order.Reference}. The following error message returned from the server. ${e.response.data.error}.`
                store.Modal.openModal(
                    <MessageModal message={message} success={false}/>
                );
                console.log(e.response.data);
            })
            .finally(() => {
                console.log('Done OnCancel function')
            });
    };

    const cancelAction: any = {
        name: "Reject Order",
        description: "Reject Order",
        icon: "cross",
        type: "icon",
        color: "danger",
        onClick: onCancel
    }

    const openSupportTicket = (order: any) => {
        history.push(`/tickets/create/${order.Reference}`)
    }
    const supportAction: any =
        {
            name: 'Support',
            description: 'Ask Admin for help',
            icon: 'help',
            type: 'icon',
            onClick: openSupportTicket,
        }


    const actions = [
        invoiceAction, cancelAction, supportAction
    ];


    const [message, setMessage] = useState(
        <EuiEmptyPrompt
            iconType="editorStrike"
            title={<h2>No Orders fits the search criteria</h2>}
            body={
                <Fragment>

                </Fragment>
            }
            actions={
                <EuiButton color="primary" fill>
                    Load orders
                </EuiButton>
            }
        />
    );

    const fields = [
        {
        field: 'Reference',
        name: 'Reference',
        sortable: true,
        truncateText: true,
        render: (reference: string) => {
            return (<NavLink to={`orders/edit/${reference}`}>
                {reference}
            </NavLink>)
        }
    },
        {
            field: 'SendingAmount',
            name: 'Sending',
            truncateText: true,
            render: (value: any, item: Order) => {
                return `${item.SendingCurrencySymbol} ${value}`
            }

        },
        {
            field: 'ReceivingAmount',
            name: 'Receiving',
            truncateText: true,
            render: (value: any, item: Order) => {
                return `${item.ReceivingCurrencySymbol} ${value}`
            }

        },
        {
            field: 'ExchangeRate',
            name: 'Rate',
            truncateText: true,
            render:(value:any, item:Order)=>{
                if(value===0)
                    return <EuiBadge color={'#0000FF'}>{`Fees : ${item.Fees}`}</EuiBadge>
                return value
            }
        },
        // {
        //     field: 'CreatedByName',
        //     name: 'Created By',
        //     truncateText: true,
        // },
        {
            field: 'DeliveryOffice',
            name: 'Branch',
            truncateText: true,
            sortable: true,
        },
        {
            field: 'CreatedAt',
            name: 'CreatedAt',
            truncateText: true,
            render: (date: any) => formatDate(date, "dobLong"),
            sortable: true,

        },
        {
            field: 'DeliveryType',
            name: 'Trasnfer Type',
            truncateText: true,
            render: (type: string) => {
                if (type==='0')
                    return <EuiBadge color="#FFA500">Bank Transfer</EuiBadge>

                return <EuiBadge color="#BADA55">Cash</EuiBadge>
            }
        }
        ,
        {
            field: 'BeneficiaryName',
            name: 'Beneficiary',


        },
        {
            field: 'BeneficiaryPhone',
            name: 'phone',


        },
        {
            field: 'Status',
            name: 'Status',
            truncateText: true,
            render: (type: any) => {
                if (type === 0)
                    return <EuiBadge color="warning">Pending</EuiBadge>
                if (type === 1)
                    return <EuiBadge color="secondary">Ready</EuiBadge>
                if (type === 2)
                    return <EuiBadge color="primary">Paid</EuiBadge>
                if (type === 3)
                    return <EuiBadge>Rejected</EuiBadge>
                if (type === 4)
                    return <EuiBadge color="danger">Cancelled</EuiBadge>
                if (type === 5)
                    return <EuiBadge color="#FCF7BC">In Progress</EuiBadge>

            }
        },
        {
            field: 'PaidAt',
            name: 'Paid At',
            sortable: true,
            render: (date: any) => formatDate(date, "dobLong"),
        },
        {
            name: "Actions",
            actions,
        },
    ]

    const searchFilters: SearchFilterConfig[] = [
        {
            type: 'field_value_toggle_group',
            field: 'Status',
            items: [
                {
                    value: 1,
                    name: 'Ready For Collection'
                },
                {
                    value: 2,
                    name: 'Paid'
                },
                {
                    value: 5,
                    name: 'In Progress'
                }
            ]
        },
        {
            type: 'field_value_selection',
            field: 'DeliveryOffice',
            name: 'Branch',
            options: branches,
            multiSelect: 'or'
        },
        {
            type: 'field_value_toggle_group',
            field: 'CreatedAt',
            items: [
                {
                    value: today,
                    name: 'Today'
                }
            ]
        },
    ]
    const schema = {
        strict: false,
        fields: {
            'CreatedAt': {
                type: 'date',
            },
        }
    };
    const searchSettings: EuiSearchBarProps = {
        box: {
            incremental: true,
            schema: true,
            placeholder: ''
        },
        filters: searchFilters
    }
    const selectionValue = {
        selectable: (order: any) => true,
        initialSelected: selection,
        onSelectionChange: (selection: any) => {
            setSelection(selection);
            console.log(selection);
        },
    };
    const breadcrumbs = [
        {
            text: 'Remittance App',
            href: '#',
            onClick: (e: any) => {
                e.preventDefault();
            },
            'data-test-subj': 'breadcrumbsAnimals',
        },
        {
            text: 'Transfer Orders',
            href: '#',
            onClick: (e: any) => {
                e.preventDefault();
            },
        },
    ];
    return (
<Fragment>
    <EuiPanel hasShadow={true} paddingSize={'l'}>
        {/*{ <EuiSuperDatePicker onTimeChange={onTimeChange}/>}*/}
            {/*{<EuiSearchBar query={query}/>}*/}

        <EuiText>
            <div className="mt-0 ">
                The below query field will be auto populated when clicking the filter buttons. Pls the status of orders are represented n numbers
                <br/> To filter by date edit the date Example before 29 June and after 1st feb
                <br/>  CreatedAt&lt;'2022-06-29' CreatedAt&gt;'2022-02-01'
            </div>

        </EuiText>
        <EuiInMemoryTable items={store.Orders.SupervisorOrders} pagination={true} columns={fields} sorting={true}
                          search={searchSettings} isSelectable={true} selection={selectionValue}
                          itemId="Reference" message={message}
                          loading={loading}
        />
    </EuiPanel>
</Fragment>


    );
};

export default observer(SupervisorOrderList)
